import { useQuery } from "@tanstack/react-query";
import { fetchOauthConsent } from "../api/index.js";
import { queryKeys } from "../query-keys.js";

/**
 * What the consent screen shows for the app's ask. Asked once: the app, its
 * address and the person do not change while the screen is open.
 */
export function useOauthConsent(search: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.oauthConsent(search),
    queryFn: () => fetchOauthConsent(search),
    enabled,
    retry: false,
    staleTime: Number.POSITIVE_INFINITY,
  });
}
